import { z } from 'zod';
import { request } from './client';

export const memberRoleSchema = z.enum(['admin', 'editor', 'viewer']);
export type MemberRole = z.infer<typeof memberRoleSchema>;

export const memberSchema = z.object({
  id: z.string(),
  email: z.string(),
  nickname: z.string().nullable().optional(),
  avatarKey: z.string().nullable().optional(),
  role: memberRoleSchema,
  joinedAt: z.string(),
});
export type Member = z.infer<typeof memberSchema>;

export const invitationSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  email: z.string(),
  role: memberRoleSchema,
  token: z.string(),
  status: z.string(),
  expiresAt: z.string(),
  createdAt: z.string(),
  inviteUrl: z.string(),
});
export type Invitation = z.infer<typeof invitationSchema>;

export const membersApi = {
  /** 列出空间成员 */
  list: (wsId: string) => request<Member[]>(`/workspaces/${wsId}/members`),

  /** 邀请成员 */
  invite: (wsId: string, body: { email: string; role?: MemberRole }) =>
    request<Invitation>(`/workspaces/${wsId}/members`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  /** 修改成员角色 */
  updateRole: (wsId: string, userId: string, role: MemberRole) =>
    request<{ workspaceId: string; userId: string; role: MemberRole; updated: boolean }>(
      `/workspaces/${wsId}/members/${userId}`,
      { method: 'PATCH', body: JSON.stringify({ role }) },
    ),

  /** 移除成员 */
  remove: (wsId: string, userId: string) =>
    request<{ workspaceId: string; userId: string; removed: boolean }>(
      `/workspaces/${wsId}/members/${userId}`,
      { method: 'DELETE' },
    ),
};
